module.exports = __webpack_public_path__ + "img/average.8fce109e.svg";